(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["waitlist-prompt"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("wishlistPromptModal");
  const overlay = document.getElementById("wishlistOverlay");
  const closeBtn = document.querySelector(".wishlist-modal-close");

  function toggleModal(active) {
    modal.classList.toggle("active", active);
    overlay.classList.toggle("active", active);
  }

  function checkPrompt() {
    const active = document.body.classList.contains("wishlist-prompt");
    toggleModal(active);
  }

  checkPrompt();

  const observer = new MutationObserver(checkPrompt);
  observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

  closeBtn.addEventListener("click", function () {
    document.body.classList.remove("wishlist-prompt");
    toggleModal(false);
  });

  overlay.addEventListener("click", function () {
    document.body.classList.remove("wishlist-prompt");
    toggleModal(false);
  });
});
  } catch(e) { console.error(e); }
})();

})();
